<template>
  <form
    action="/api/quotation"
    id="form_car"
    class="mt-30"
    method="POST"
    @submit="handleSubmit"
    ref="classicCar"
  >
    <input type="hidden" name="quotation_id" :value="quotationId" />
    <input type="hidden" name="quotation_type" :value="currentQuotationType" />
    <classic-bike-container :infobike="infobike"></classic-bike-container>
    <buy-quotation-btn
      type="ruote-classiche"
      @submit-form="onSubmitForm"
      :liveMarketExists="false"
      :promotions="promotions"
      :acquisto-cta="acquistoCta"
    ></buy-quotation-btn>
  </form>
</template>

<script>
import ClassicBikeContainer from './ClassicBikeContainer.vue';
import BuyQuotationBtn from './BuyQuotationBtn.vue';

export default {
  name: 'ClassicBikeData',
  components: {
    ClassicBikeContainer,
    BuyQuotationBtn,
  },
  props: {
    quotationId: {
      type: Number,
      required: true,
    },
    infobike: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    promotions: {
      type: Object,
      required: false,
    },
    acquistoCta: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      currentQuotationType: this.type,
    };
  },
  methods: {
    handleSubmit() {
      this.loading = true;
    },
    onSubmitForm(newType) {
      this.currentQuotationType = newType;
      this.$nextTick(() => {
        this.$refs.classicCar.submit();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ClassicBikeData.vue